const GlobeIconSVG = ({ className = "", stroke = "white" }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_4739_5838)">
        <path
          d="M7.99967 14.6667C11.6816 14.6667 14.6663 11.6819 14.6663 8C14.6663 4.3181 11.6816 1.33334 7.99967 1.33334C4.31778 1.33334 1.33301 4.3181 1.33301 8C1.33301 11.6819 4.31778 14.6667 7.99967 14.6667Z"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.33301 8H14.6663"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.99967 1.33334C9.66719 3.1589 10.6148 5.52802 10.6663 8C10.6148 10.472 9.66719 12.8411 7.99967 14.6667C6.33215 12.8411 5.38451 10.472 5.33301 8C5.38451 5.52802 6.33215 3.1589 7.99967 1.33334Z"
          stroke={stroke}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4739_5838">
          <rect width="16" height="16" fill={stroke} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default GlobeIconSVG;
